import React from 'react'
import { Link } from 'react-router-dom'

const FAQs = (props) => {

  window.scrollTo(0,0);

  return (
    <section className="sobre-pedraza">
    <div className="container">
      <div className="row">
        <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1>Preguntas Frecuentes (FAQs)</h1>
          <hr />
          <div id="accordion">
            <div className="card">
              <div className="card-header" id="headingOne">
                <h5 className="mb-0">
                  <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    ¿Cu&aacute;les son las formas de pago?
                  </button>
                </h5>
              </div>

              <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div className="card-body">
                  Las compras podrán abonarse con tarjeta de cr&eacute;dito, dep&oacute;sito bancario o transferencia electr&oacute;nica a través de la web o bien en cualquiera de nuestras sucursales. Luego de elegir el paquete correspondiente, se te informarán las opciones para que realices el pago con tu tarjeta de crédito de forma fácil y segura. En caso de realizar la compra a través de Ventas Telef&oacute;nicas o en una de Nuestras Sucursales, la misma podrá ser realizada en efectivo o con cualquiera de los medios de pago mencionados anteriormente.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingTwo">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  ¿C&oacute;mo puedo cancelar mi reserva?
                  </button>
                </h5>
              </div>
              <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                <div className="card-body">
                  La cancelaci&oacute;n de las reservas realizadas podr&aacute;n hacerse por medio fehaciente. Dicha cancelaci&oacute;n queda sujeta a lo establecido en el &iacute;tem cancelaciones, dentro de las <Link to="/terminos-y-condiciones">Condiciones Generales de Contrataci&oacute;n</Link> . Haga click <Link to="/terminos-y-condiciones">aqu&iacute;</Link> si quiere ver m&aacute;s
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    ¿Qu&eacute; documentaci&oacute;n debo llevar para viajar al exterior?
                  </button>
                </h5>
              </div>
              <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  En la web oficial de <a href="http://www.migraciones.gov.ar/site_docs/" target="_blank" rel="noopener noreferrer">MIGRACIONES</a> puede conocer cuales son los documentos válidos para viajes en el exterior. Haga click <a href="http://www.migraciones.gov.ar/site_docs/" target="_blank" rel="noopener noreferrer">aquí</a>  para ir al sitio
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
                    ¿En qu&eacute; momento recibo mi voucher?
                  </button>
                </h5>
              </div>
              <div id="collapseFour" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  Los voucher estan disponibles aproximadamente una semana antes de la fecha de Salida del viaje. Pueden ser retirados personalmente en nuestras oficinas o solicitar el envio del mismo por mail
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                    ¿Los menores de edad abonan la misma tarifa?
                  </button>
                </h5>
              </div>
              <div id="collapseFive" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  Los menores de 2 años no abonan y no tienen servicio. Con 2 años cumplidos abonan la totalidad del tour. Se toma como referencia ela fecha de salida del viaje
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
                    ¿Se puede elegir la ubicaci&oacute;n en el micro?
                  </button>
                </h5>
              </div>
              <div id="collapseSix" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  No otorgamos numeros de butacas y ubicacion predestinada. El asiento lo otorga el coordinador en el momento de subir al bus. De todas maneras tratamos de tener en cuenta los requerimientos de nuestros pasajeros en el armado de la taquilla.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree">
                    ¿Puede viajar una persona sola?
                  </button>
                </h5>
              </div>
              <div id="collapseSeven" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  Nuestros productos estan armados en base doble, es decir minimo 2 personas por habitacion. De todas maneras en muchos de nuestros destinos una persona sola puede contratar nuestro paquete abonando un 50% mas del total. Tambien tenemos salidas especificas para gente que viaja sola compartiendo la habitacion, este producto se llama <strong>SOLO PARA GENTE SOLA</strong>.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseThree">
                    ¿Cuando debo terminar de abonar mi viaje?
                  </button>
                </h5>
              </div>
              <div id="collapseEight" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  Una vez señado su viaje tiene tiempo hasta 10 dias antes de la salida para completar el pago total.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="headingThree">
                <h5 className="mb-0">
                  <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseThree">
                    ¿Las comidas en el viaje están incluidas?
                  </button>
                </h5>
              </div>
              <div id="collapseNine" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div className="card-body">
                  Las comidas en el viaje no están incluidas dentro del paquete. En el viaje se realizan paradas en paradores turisticos donde brindan el servicio de comidas ya sea para desayuno, almuerzo o cena.
                </div>
              </div>
            </div>
          </div>

        </article>
      </div>


    </div>
  </section>
  )
}

export default FAQs



// WEBPACK FOOTER //
// ./src/components/Global/FAQs.js